export default "__VITE_ASSET__CIlEr81Z__"